export enum MENU_ROUTES {
  Home = 'home',
  Projects = 'projects',
  JoinUs = 'joinus',
  // News = 'news',
  // NewsAndEvents = 'newsAndEvents',
  About = 'about',
  Documents = 'documents',
  Standards = 'standards',
  Other = 'other',
  // Cooperation = 'cooperation',
  // Contact = 'contact',
  ProjectsDetails = 'projectsDetails',
  Support = 'support',
  UserAgreement = 'userAgreement',
  Reports = 'reports',
  Donate = 'donate',
  DonateTest = 'donatetest',
  Success = 'success',
  Contact = 'contact',
}

export const ROUTES_PATH: { [key in MENU_ROUTES]: string } = {
  [MENU_ROUTES.About]: '/about',
  [MENU_ROUTES.Documents]: '/documents',
  [MENU_ROUTES.Standards]: '/standards',
  [MENU_ROUTES.Other]: '/other',
  [MENU_ROUTES.Home]: '/',
  // [MENU_ROUTES.Contact]: '/contact',
  // [MENU_ROUTES.Cooperation]: '/cooperation',
  // [MENU_ROUTES.News]: '/news',
  // [MENU_ROUTES.NewsAndEvents]: '/news',
  [MENU_ROUTES.Projects]: '/projects',
  [MENU_ROUTES.JoinUs]: '/joinus',
  [MENU_ROUTES.ProjectsDetails]: '/projects/:id',
  [MENU_ROUTES.Support]: '/support',
  [MENU_ROUTES.UserAgreement]: '/user_agreement',
  [MENU_ROUTES.Reports]: '/reports',
  [MENU_ROUTES.Donate]: '/donate',
  [MENU_ROUTES.DonateTest]: '/donatetest',
  [MENU_ROUTES.Contact]: '/contact',
  [MENU_ROUTES.Success]: '/success',
};
